import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { AmbarAgreementService } from '../../../services/AmbarAgreementService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetAmbarAgreementListPagingAndFilterRequest, initialGetAmbarAgreementListPagingAndFilterRequest } from '../../../models/request/ambarAgreement/GetAmbarAgreementListPagingAndFilterRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { DeleteAmbarAgreementResponse } from '../../../models/response/ambarAgreement/DeleteAmbarAgreementResponse';
import { GetAmbarAgreementListPagingAndFilterResponse, GetAmbarAgreementListPagingAndFilterResponseData, GetAmbarAgreementListPagingAndFilterResponseItem, initialGetAmbarAgreementListPagingAndFilterResponseData } from '../../../models/response/ambarAgreement/GetAmbarAgreementListPagingAndFilterResponse';
import { ExportAmbarAgreementListResponse } from '../../../models/response/ambarAgreement/ExportAmbarAgreementListResponse';
import AmbarAgreementListFilters from './Components/AmbarAgreementListFilters';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { AmbarAgreementSchemeService } from '../../../services/AmbarAgreementSchemeService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const AmbarAgreementList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Kargo Modülü > Nakliye > Anlaşma"
    const pageVersion = "2";
    const [data, setData] = useState<GetAmbarAgreementListPagingAndFilterResponseData>(initialGetAmbarAgreementListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetAmbarAgreementListPagingAndFilterRequest>(initialGetAmbarAgreementListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Kod', name: 'refNo', order: 0, isVisible: true },
            { title: 'Şablon', name: 'agreementSchemeName', order: 0, isVisible: true },
            { title: 'Başlangıç Tarihi', name: 'startDateStr', order: 0, isVisible: true },
            { title: 'Bitiş Tarihi', name: 'endDateStr', order: 0, isVisible: true },
            { title: 'Birim Fiyat', name: 'unitPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Minimum Fiyat', name: 'minPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * (filter.take ?? 0)
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteAmbarAgreement = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.ambarAgreementId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteAmbarAgreementResponse = await AmbarAgreementService.deleteAmbarAgreement(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateAmbarAgreement = async (_id: string | undefined = undefined) => {
        navigate('/ambaragreement/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].ambarAgreementId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetAmbarAgreementListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetAmbarAgreementListPagingAndFilterResponse = await AmbarAgreementService.getAmbarAgreementListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var oldColumns = getColumns();

            var newColumns = [...new Set(response.data.items.flatMap(x => Object.keys(x)).filter(x => x.startsWith("dynamic ")))].filter(x => !oldColumns.map(a => a.name).includes(x));

            setColumns([...oldColumns, ...newColumns.map(function (x) {
                return { title: x.replace("dynamic ", ""), name: x, order: 99, isVisible: true }
            })]);

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.ambarAgreementId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var obj: GetAmbarAgreementListPagingAndFilterRequest = buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.ambarAgreementId), columns);

            var response: ExportAmbarAgreementListResponse = await AmbarAgreementService.exportAmbarAgreementList(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }


    // Başlığa tıklayarak sıralanabilen kolonlar. Şablondan gelen kolonlar da
    // sıralanabilir; sıralama listede görünen ada göre yapılır (backend tarafı).
    const sortableColumns = React.useMemo(() => [
        'refNo', 'agreementSchemeName',
        'startDateStr', 'endDateStr',
        'unitPrice', 'minPrice',
        'createdUser', 'updatedUser',
        ...columns.filter(x => x.name.startsWith('dynamic ')).map(x => x.name)
    ], [columns]);

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (AmbarAgreementManager.ApplyColumnFilters) aynı.
    const sabitFiltreler: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        agreementSchemeName: { type: 'select', loadOptions: () => loadList(AmbarAgreementSchemeService.getAmbarAgreementSchemeList(), 'ambarAgreementSchemeId', x => x.name) },
        startDateStr: { type: 'date' },
        endDateStr: { type: 'date' },
        unitPrice: { type: 'number' },
        minPrice: { type: 'number' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    /**
     * Şablondan gelen kolonlara da seçimli filtre verilir. Seçenekler, o alanda
     * kullanılmış farklı değerlerden oluşur; süzme listede görünen ad üzerinden değil
     * kayıtta tutulan değer üzerinden yapılır. "(Boş)" seçeneği alanı doldurulmamış
     * anlaşmaları getirir.
     */
    const columnFilterDefinitions: ColumnFilterDefinitions = React.useMemo(() => {
        const tanimlar: ColumnFilterDefinitions = { ...sabitFiltreler };

        for (const kolon of columns.filter(x => x.name.startsWith('dynamic '))) {
            const alanAdi = kolon.name.replace('dynamic ', '');

            tanimlar[kolon.name] = {
                type: 'select',
                loadOptions: () => loadList(AmbarAgreementService.getAmbarAgreementFieldValues(alanAdi), 'value', x => x.name)
            };
        }

        return tanimlar;
    }, [columns]);

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetAmbarAgreementListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreement(item.ambarAgreementId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreement(item.ambarAgreementId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['unitPrice', 'minPrice'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreement(item.ambarAgreementId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreement(item.ambarAgreementId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <AmbarAgreementListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteAmbarAgreement}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateAmbarAgreement}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2 px-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className="new-table-container">
                            <table>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>

                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => setItemSelected(item.ambarAgreementId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={(filter.take ?? 0)}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / (filter.take ?? 0))}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default AmbarAgreementList;